export const LOGO = "https://customer-assets-7cd3h4nn.emergentagent.net/job_mlfab-fire-safety/artifacts/dc917e3793eac4e3_IMG-20260925-WA0026.jpg";

export const CONTACT = {
  phone: "+91 97113 30711",
  tel: "tel:+919711330711",
  info: "info@mlfabenterprises.com",
  sales: "sales@mlfabenterprises.com",
  whatsapp: "919149519798",
  address: "Plot No. 2 GF, Khasra No. 76/22/1, Nearby JK Associates, Bakarwala, New Delhi, West Delhi, Delhi – 110041",
};

export const waLink = (text = "Hello ML FAB Enterprises, I need a fire safety vehicle quotation.") =>
  `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(text)}`;

const A = "https://customer-assets-7cd3h4nn.emergentagent.net/job_mlfab-fire-safety/artifacts/";
export const PHOTOS = {
  hero: "https://customer-assets-jt897jd0.emergentagent.net/job_398eb0cc-8bb0-4c12-b915-aa536cef729a/artifacts/7cf3740d51fbc3cf_motion_photo_8631149086718940705.jpg",
  tender: "https://customer-assets-jt897jd0.emergentagent.net/job_398eb0cc-8bb0-4c12-b915-aa536cef729a/artifacts/IMG-20261007-WA0023.jpg",
  rescue: "https://customer-assets-jt897jd0.emergentagent.net/job_398eb0cc-8bb0-4c12-b915-aa536cef729a/artifacts/IMG-20261007-WA0025.jpg",
  fleet: `${A}72f6b1251e77d7c1_IMG-20261007-WA0032.jpg`,
  delivered: `${A}58c0473ed73fc4df_IMG-20261007-WA0030.jpg`,
  mist: `${A}52a2d05502bd32e0_IMG-20261007-WA0020.jpg`,
  pump: `${A}a436b94e4c173eda_IMG-20261007-WA0027.jpg`,
};

export const SERVICE_OPTIONS = ["Bulk Vehicle / Equipment Quote", "Fire Truck Manufacturing", "Specialized Equipment", "Fire Manpower & Staffing", "GeM & E-Tender Support", "Safety Audit"];
export const STATUS_OPTIONS = ["New Lead", "Under Review", "Quotation Sent", "Converted", "Lost"];
